import React from 'react';
import Card from './Card';

export default function EvolvableCard({ title, subtitle, className, year, petrobrasData = {}, children }) {
  const refDate = petrobrasData?.informacao_financeira?.find(x => x.DataReferenciaDocumento)?.DataReferenciaDocumento || petrobrasData?.distribuicao_dividendos?.[0]?.DataReferenciaDocumento || null;

  return (
    <Card 
      title={title} 
      subtitle={subtitle}
      refDate={refDate} 
      className={className}
      action={null}
    >
      {children(petrobrasData, year)}
    </Card>
  );
}
